import type { GraphCacheUpdaters } from "@/graphql/generated"

export const subscriptionMutationUpdaters = {
  unsubscribeFrom(result, _args, cache) {
    const subscriptionId =
      result.unsubscribeFrom?.__typename === "MutationUnsubscribeFromSuccess" &&
      result.unsubscribeFrom.data?.id

    if (subscriptionId) {
      cache.invalidate({
        __typename: "Sub",
        id: subscriptionId,
      })
    }
  },
} satisfies NonNullable<GraphCacheUpdaters["Mutation"]>
